import { Result, failure, success } from '../shared'
import { FilesActionProvider } from './providers'
import { LinkedFilesFailure, LinkedFilesActions } from './models/linkedFiles.types'
import { LinkedFilesParams, ViewFilesParams } from './models'
import { ViewFilesProvider } from './providers/viewFiles.provider'
import { UploadFilesProvider } from './providers/uploadFiles.provider'
import { UploadFileParams } from './models/uploadFile-prams.model'

export class LinkedFilesService {
  constructor(
    private readonly fileActionProviders: FilesActionProvider,
    private readonly viewFileProvider: ViewFilesProvider,
    private readonly uploadFileProvider: UploadFilesProvider,
  ) {}

  public async fileAction(
    action: LinkedFilesActions,
    params: LinkedFilesParams,
  ): Promise<Result<any, LinkedFilesFailure>> {
    try {
      const { data } = await this.fileActionProviders.fileAction(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async toggleFileVisaAction(
    action: LinkedFilesActions,
    params: LinkedFilesParams,
  ): Promise<Result<any, LinkedFilesFailure>> {
    try {
      const { data } = await this.fileActionProviders.fileAction(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async view(params: ViewFilesParams): Promise<Result<any, LinkedFilesFailure>> {
    try {
      const { data } = await this.viewFileProvider.view(params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async upload(params: UploadFileParams): Promise<Result<any, LinkedFilesFailure>> {
    try {
      const { data } = await this.uploadFileProvider.upload(params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }
}
